export default __webpack_public_path__ + "static/event-logo-8a2e3e8431dfc4c2228d39e8ee823da7.jpg";